<script>
    import { user_data, isEmptyOrSpaces, cleanCurrency, emitter } from './stores.js';
    import FooterComponent from './components/footercomponent.svelte';
    import CTA from './components/ctacomponent.svelte';
    import Iqtcallout from "./components/iqtcallout.svelte";
    import Overlay from "./components/overlaycomponent.svelte";
    import { onMount } from "svelte";

    // function gtag_report_conversion(url) { 
    //     console.log("marked contact form conversion");

    //     let callback = function () { 
    //         if (typeof(url) != 'undefined') { 
    //             // window.location = url; 
    //         } }; 
    //     gtag('event', 'conversion', { 'send_to': 'AW-516862134/p83QCPKXr5EDELbhuvYB', 'event_callback': callback }); return false; 
    // }


    let schedule_element;
    onMount(async () => {
console.log("doing on mount");

// gtag('event', 'purchase', {
//   'event_category' : 'ecommerce',
//   'event_label' : 'conversion'
// });


    // gtag_report_conversion('https://www.gethomeeasy.com/#/dfp_thank_you');

    setTimeout(() => {
            $emitter.on('scheduleClick', ()=>{
                schedule_element.classList.add("expanded"); 
                setTimeout(() => {
                    scrollToTop();                
                }, 250);
                
            });
        });
    });
    // const scrollBy = (amount) => {
    // // const c = document.documentElement.scrollTop || document.body.scrollTop;
    //     if (amount > 0) {
    //         window.requestAnimationFrame(scrollBy);
    //         window.scrollBy(0, amount - amount / 8);
    //     }
    // };
    // scrollToTop();
    const scrollToTop = () => {
        console.log(schedule_element.getBoundingClientRect());
        const c = schedule_element.getBoundingClientRect().y ;
        if (c > 100) {
            window.requestAnimationFrame(scrollToTop);
            window.scrollBy(0, c - c / 8);
        }
    };    

    function doBookNow(){
        schedule_element.classList.add("expanded"); 
                setTimeout(() => {
                    scrollToTop();                
                }, 250);
    }

</script>

<div class="maincontainer">


    <div class="navcontainer">
        <div class="logocontainer">
            <a href="/"><img src="/img/HomeEasy_logo_dark_grey-01.png" alt="Semper Home Loans Logo"></a>
        </div>

        <div class="numbercontainer">
            <div class="phoneiconcontainer"><img src="/img/Phone_contact.svg" alt="Semper Home Loans Logo"></div>
            <div class="phonenumber"><a href="tel:+8665283814">(866) 528-3814</a></div>
            <!-- <div class="signin">Sign In</div> -->
        </div>

    </div>

    <div class="headercontainer">
        <div class="headericoncontainer">
            <img alt="thank you" src="/img/tracker_check.png" />
        </div>
    </div>

    <div class="ctacontainer">
        <CTA
        title="Thank you!"
        copy="Below are your next steps. We’ll be in touch with you shortly."
        >
            <Iqtcallout
            show_dropshadows={true}
            logo="/img/Card_phone.svg"
            title="Talk to an Expert"
            text="Call an experienced Loan Officer to get the ball rolling."
            button_text="Call now"
            button_color_reversed={false}
            button_link="tel:866-528-3814"
            />
        <Iqtcallout
            show_dropshadows={true}
            logo="/img/Calendar_check.svg"
            title="Schedule a Call"
            text="Make an appointment time that works for you to speak with Loan Officer."
            button_text="Book appointment"
            button_color_reversed={false}
            button_function={()=>{
                // $emitter.emit("scheduleClick");
                doBookNow();
            }}
        />
        <Iqtcallout
            show_dropshadows={true}
            logo="/img/House_2.svg"
            title="Apply in Minutes"
            text="Complete your application through our HomeEasy® app for your rate."
            button_text="Finish application"
            button_color_reversed={false}
            button_link="https://homeeasy.semperhl.com/homehub/signup/ASKSEMPER@SEMPERHL.COM"
            />
    
        </CTA>        

        <div bind:this={schedule_element} class="scheduleholder">
            <iframe title="" src="https://outlook.office365.com/owa/calendar/SemperHomeLoans4@semperhl.com/bookings/" frameborder="0"></iframe>
        </div>
        
    </div>

    <div class="footercontainer">
        <FooterComponent 
        show_top_border={true}
        />
    </div>    


</div>

<style>
.scheduleholder {
    position: absolute;
    left: 0;
    width: 100vw !important;
    transition: height .5s ease-in-out;
    height: 0;
    /* padding-bottom: 56.25%;     */
}
:global(.scheduleholder.expanded) {
    height: 1400px !important;
}
.scheduleholder iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

}

/* :global(.progresstextholder.shown) {
    transition: opacity 1s;
    opacity: 0; */
    /* animation: flipV 1s linear; */
    /* transform: rotateX(90deg); */
    /* transform: rotateX(180deg); */
    /* transform-origin: 50% 100%; */
    
/* } */

/* @keyframes flipV {
    0%{
        transform: rotateX(90deg)
    }
    to{
        transform: rotateX(0deg);
    }
} */
/* animation: createCallout 0.5s; */
    /* animation-timing-function: ease-out; */
@keyframes createCallout {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}
 .maincontainer {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0px;
    background-color: white;
    box-sizing: border-box;
    align-items: center;
}

.navcontainer {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
}
.logocontainer {
    width: 100%;
    padding: 20px;
}
.logocontainer img {
    height: 32px;
}

.numbercontainer {
    display: flex;
    align-items: center;
    width: 200px;
    color: var(--placeholdergray);
    /* margin-right: 40px; */
}
.phoneiconcontainer {
    display: flex;
    justify-content: center;
    align-items: center;
}
.phoneiconcontainer img {
    width:  1em;
    height: 1em;
}
.phonenumber {
    font-size: 1em;
    margin-left: 10px;
}
.phonenumber a {
    text-decoration: none;
    color: var(--blueslate);
}
.headericoncontainer img{
    width: 100px;
    height: 100px;
}
.footercontainer {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 50px;
}
.showmobile {
    display: none;
}

@media (max-device-width: 1024px), (max-width: 1023px) {
    .showmobile {
        display: block;
    }
    .showdesktop {
        display: none;
    }

    .navcontainer {
        width: 100%;
        max-width: 411px;
        border-bottom: 1px solid var(--darkgray);
        justify-content: space-between;
        padding-left: 20px;
        padding-right: 20px;
        box-sizing: border-box;
        margin-bottom: 40px;
    }
    .logocontainer {
        width: auto;
        padding: 0px;
    }
    .logocontainer img {
        height: 32px;
    }
    
    .numbercontainer {
        width: auto;
        /* margin-right: 40px; */
    }
    .phonenumber {
        font-size: 0.75em;
        margin-left: 10px;
    }


}   
</style>